import { FormikProps } from 'formik';
import { TextFieldNoLabel } from '../../../components/index';
import { SignUpFormProps } from '../types/sign-up-form-types';

const PasswordInput = ({formik} : {formik: FormikProps<SignUpFormProps>}) => {
  const inputProps = {
    value: formik.values.password,
    onChange: formik.handleChange,
    error: formik.touched.password && Boolean(formik.errors.password),
    helperText: formik.touched.password && formik.errors.password,
  }
  return (
    <TextFieldNoLabel textDesc='Password' name="password" inputProps={inputProps} type='password' isRequired placeholder='Enter your password' isPassword />
  )
}

export default PasswordInput;